import {
  Box,
  Container,
  Divider,
  IconButton,
  Paper,
  Tooltip,
} from "@mui/material";
import { useEffect, useState } from "react";
import { ArrowBack, CopyAll, Logout } from "@mui/icons-material";
import { useLocation } from "react-router";
import { Button, Typography } from "Atoms";
import Logo from "Assets/images/logo.png";
import Appbar from "Atoms/Appbar";
import { useBoundStore } from "Zustand/store/mainStore";
import BasicInfo from "./_tabs/BasicInfo";
import Attachments from "./_tabs/Attachments";
import TestRequirements from "Pages/ProjectDetail/_tabs/TestRequirements";

const TestSpecificationDetail = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const { logout, getTestSpecificationContent } = useBoundStore();
  const location = useLocation() as any;

  const testSpecificationNodeId =
    location.state?.testspecificationnodeid || "";
  const testSpecification =
    location.state?.testSpecification?.testspecification ||
    location.state?.testSpecification ||
    null;

  useEffect(() => {
    if (testSpecificationNodeId) {
      getTestSpecificationContent(testSpecificationNodeId);
    }
  }, [getTestSpecificationContent, testSpecificationNodeId]);

  return (
    <Container
      maxWidth="xl"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <Paper
        sx={{ width: "100%", p: 4, borderRadius: 2, height: "100%" }}
        elevation={3}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Box display="flex" alignItems="center" gap={2}>
            <Button
              variant="text"
              onClick={() => {
                window.history.back();
              }}
              startIcon={<ArrowBack />}
            >
              Back
            </Button>
          </Box>

          <Box
            display="flex"
            alignItems="center"
            gap={1}
            flexDirection={"column"}
          >
            <img src={Logo} alt="Logo" style={{ height: 40 }} />
          </Box>

          <Button
            variant="outlined"
            size="small"
            color="error"
            onClick={logout}
            startIcon={<Logout />}
          >
            Logout
          </Button>
        </Box>

        <Divider sx={{ mb: 2 }} />

        <Box display="flex" justifyContent="center" alignItems="center" mb={1}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "25px",
            }}
          >
            <Typography variant="body2" color="text.secondary">
              <b>Test Specification : </b>{" "}
              {testSpecification?.name || "Unnamed Test Specification"}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              <b>Node ID : </b>
              <Tooltip title={testSpecificationNodeId}>
                <Typography variant="body2" component={"span"}>
                  {testSpecificationNodeId
                    ? `${testSpecificationNodeId.substring(
                        0,
                        8
                      )}...${testSpecificationNodeId.substring(
                        testSpecificationNodeId.length - 5
                      )}`
                    : "—"}{" "}
                </Typography>
              </Tooltip>
              {testSpecificationNodeId ? (
                <Tooltip title="Copy full Test Specification ID">
                  <IconButton
                    onClick={() => {
                      navigator.clipboard.writeText(testSpecificationNodeId);
                    }}
                    style={{ cursor: "pointer", textDecoration: "underline" }}
                  >
                    <CopyAll fontSize="small" color="primary" />
                  </IconButton>
                </Tooltip>
              ) : null}
            </Typography>
          </Box>
        </Box>

        <Divider sx={{ mb: 2 }} />

        <Appbar
          tabs={[
            { label: "Basic Info", value: 0 },
            { label: "Test Requirements", value: 1 },
            { label: "Attachments", value: 2 },
          ]}
          value={tabIndex}
          onChange={(_, newValue) => setTabIndex(newValue)}
          primaryColor="primary"
          textColor="#FFFFFF"
          activeBarColor="#FFFFFF"
        />

        <Box mt={2}>
          {tabIndex === 0 && (
            <BasicInfo testSpecificationNodeId={testSpecificationNodeId} />
          )}
          {tabIndex === 1 && (
            <TestRequirements
              entityType="testspecification"
              parentNodeId={testSpecificationNodeId}
            />
          )}
          {tabIndex === 2 && (
            <Attachments testSpecificationNodeId={testSpecificationNodeId} />
          )}
        </Box>
      </Paper>
    </Container>
  );
};

export default TestSpecificationDetail;
